/**
 * Filter to converter string a lowercase
 * @version 1.0.0
 * @author Efrén Martínez Rodríguez
 * @copyright Marciano Studio S.C., 2018
 */
import Vue from 'vue'
export default Vue.filter('lowercase', value => value.toLowerCase())



// WEBPACK FOOTER //
// ./src/filters/string.filters/lowercase.filter.js